/**
 * Regex Utils Module (renamed from utils/regex-patterns.js)
 * Common regex patterns and string utilities
 */

"use strict";

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

// Export regex patterns
export const reAllLetters = '[A-Za-zА-Яа-яЁё]';
export const reNonBoundaryE = '[\\p{L}\\p{N}]';
export const reIntBoundaryS = '(?<![\\p{L}\\p{N}\\-])';
export const reIntBoundaryE = '(?![\\p{L}\\p{N}\\-])';
export const reIntBoundaryS2 = '(?<![\\p{L}\\p{N}])';
export const reIntBoundaryE2 = '(?![\\p{L}\\p{N}])';

// Date patterns
export const fileNameDatePattern = '(\\b\\d{2}(?:\\.| )?(?:1[0-2]|0?[1-9])(?:\\.| )?(?:(?:19|20)?\\d{2}|(?:(?:19|20)?)?\\d{2})\\b|\\b(?:(?:19|20)?\\d{2}|(?:(?:19|20)?)?\\d{2})(?:\\.| |\\-)(?:1[0-2]|0?[1-9])(?:\\.| |\\-)\\d{2}\\b|(?:(?:[А-ЯA-Z]{1,5}|SHSpec)\\-?\\d{2,4}|(?:\\d{2}\\-?)?\\d{4})[\\dA-ZА-Яcm]*)';
export const fileNameDatePatternShort = '^(\\d{2}(?:\\.| )?(?:1[0-2]|0?[1-9])(?:\\.| )?(?:(?:19|20)?\\d{2}|(?:(?:19|20)?)?\\d{2})\\b|(?:(?:19|20)?\\d{2}|(?:(?:19|20)?)?\\d{2})(?:\\.| |\\-)(?:1[0-2]|0?[1-9])(?:\\.| |\\-)\\d{2}|(?:(?:[А-ЯA-Z]{1,5}|SHSpec)\\-?\\d{2,4}|(?:\\d{2}\\-?)?\\d{4})[\\dA-ZА-Яcm]*)';

export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function qRep(inp, simple = false, extraReplace = '') {
    inp = inp.replace(/(?<!\))\?(?!:)/g, '[^\\s/]').replace(/\*/g, (simple ? '.*' : `[${reNonBoundaryE}]*`));
    if (extraReplace != '') { 
        inp = inp.replace(new RegExp(extraReplace, 'g'), (simple ? '.*' : `[^${reNonBoundaryE}]+`));
    }
    return inp;
}

String.prototype.replaceMulti = function(replacements) {
    let result = this;
    for (const [pattern, replacement] of Object.entries(replacements)) {
        result = result.replace(new RegExp(pattern, 'g'), replacement);
    }
    return result;
};

export function cartesianProduct(arrays) {
    if (!arrays || arrays.length === 0) {
        return [];
    }
    const validArrays = arrays.filter(arr => arr && arr.length > 0);
    if (validArrays.length === 0) {
        return [];
    }
    if (validArrays.length === 1) {
        return validArrays[0].map(item => [item]);
    }
    return validArrays.reduce((a, b) => 
        a.flatMap(d => b.map(e => [d, e].flat()))
    );
}

export function sort_array_based_on_example(array, example) {
    array.sort((a, b) => {
        const indexA = example.indexOf(a);
        const indexB = example.indexOf(b);
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
    });
}

export function sort_array_keys_based_on_example(obj, example) {
    const sorted = {};
    for (const key of example) {
        if (key in obj) {
            sorted[key] = obj[key];
        }
    }
    for (const key in obj) {
        if (!(key in sorted)) {
            sorted[key] = obj[key];
        }
    }
    return sorted;
}

export function objectFlip(obj) {
    const flipped = {};
    for (const [key, value] of Object.entries(obj)) {
        flipped[value] = key;
    }
    return flipped;
}

// Backward compatibility - expose array utilities globally
if (typeof window !== 'undefined') {
    window.cartesianProduct = cartesianProduct;
    window.sort_array_based_on_example = sort_array_based_on_example;
    window.sort_array_keys_based_on_example = sort_array_keys_based_on_example;
    window.objectFlip = objectFlip;
    // Module loaded logging only in debug mode
}


